import {createAction} from '@reduxjs/toolkit';

export const resetFilters = createAction('RESET_FILTERS');

export const applyFilters = createAction('APPLY_FILTERS');
